/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(window).on('load', function () {
  $(window)
    .scroll(function () {
      var windowBottom = $(this).scrollTop() + $(this).innerHeight() + 300
      $('.fadediv').each(function () {
        /* Check the location of each desired element */
        var objectBottom = $(this).offset().top + $(this).outerHeight()

        /* If the element is completely within bounds of the window, fade it in */
        if (objectBottom < windowBottom) {
          //object comes into view (scrolling down)
          if ($(this).css('opacity') == 0) {
            $(this).fadeTo(300, 1)
          }
        } else {
          //object goes out of view (scrolling up)
          if ($(this).css('opacity') == 1) {
            $(this).fadeTo(300, 0)
          }
        }
      })
    })
    .scroll() //invoke scroll-handler on page-load
})

$(document).ready(function () {
  setTimeout(function () {
    $('#showMe').fadeIn(1500)
  }, 3000)



/* AK_DR const for sticky header */
const headerContainer = document.querySelector('#header-placeholder');
const header = document.querySelector('#shopify-section-header');
const meilisearch = header.querySelector('.meilisearch');
const minimizedHeader = window.getComputedStyle(document.body).getPropertyValue('--header-minimized-translateY');
// const headerChildren = headerContainer.querySelector('#shopify-section-header').children;

  $(window).scroll(function () {
    if ($(this).scrollTop() >= 100) {
        // $('.Header__Wrapper').css({'padding-bottom': '0', transition: 'all .3s ease'})
        
        /* original: for fixed header -- currently not used 
        $('.Header__MainNav').css({ 'padding-bottom': '8px', transition: 'all .3s ease' })
        $('.Header__LogoImage').css({ 'max-width': '150px', transition: 'all .3s ease' })
        */

        /* AK_DR const for sticky header */
        headerContainer.classList.add('minimized'); // AK_DR -- header sticky / avoid flickering
        (minimizedHeader && minimizedHeader != '') ? meilisearch.style.marginTop = minimizedHeader : meilisearch.style.marginTop = '-30px';
    } else {
        /* original: for fixed header -- currently not used 
        $('.Header__Wrapper').css({ 'padding-bottom': '24px', transition: 'all .3s ease' })
        $('.Header__MainNav').css({ 'padding-bottom': '18px', transition: 'all .3s ease' })
        $('.Header__LogoImage').css({ 'max-width': '100%', transition: 'all .3s ease' })
        */

        /* AK_DR const for sticky header */
        headerContainer.classList.remove('minimized'); // AK_DR -- header sticky / avoid flickering
        meilisearch.style.marginTop = 'unset';
    }
    if ($(this).scrollTop() > 500) {
      $('.scrolltoTop').fadeIn(1000)
    } else {
      $('.scrolltoTop').fadeOut(1000)
    }
  })

  $(document).on('click', '.trbo-content', function () {
    $('html, body').animate({ scrollTop: 0 }, 'slow')
    return false
  })

  $(document).on('click', '.HorizontalList__Item .SizeSwatch', function () {
    var unitprice = $(this).attr('data-unitprice'),
      gastatus = $(this).attr('data-gastatus'),
      deliverytime = $(this).attr('data-deliverytime')
    $('.wtper span').text(unitprice)
    $('.ProductMeta__PriceList').attr('data-gastatus', gastatus)
    $('.deliverytime span:not(.greenCircle)').text(deliverytime)
  })

  $('.prod_carousel').flickity({
    prevNextButtons: true,
    pageDots: false,
    wrapAround: true,
    contain: true,
    cellAlign: 'left',
    arrowShape: { x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25 },
  })
  $('.SidebarMenu__Nav .submenu').each(function () {
    if ($(this).find('.Collapsible__Content .Collapsible').hasClass('site-nav--active')) {
      $(this).addClass('active')
    }
  })
  $(document).on('click', '.Icon-Wrapper--clickable[data-action="toggle-search"]', function () {
    $('body').toggleClass('search_enable')
  })
  $(document).on('click', '.Search__Close', function () {
    $('body').removeClass('search_enable')
  })
})

$(function () {
  var targets = $('[rel~=tooltip]'),
    target = false,
    tooltip = false,
    title = false

  targets.bind('mouseenter', function () {
    target = $(this)
    tip = target.attr('title')
    tooltip = $('<div id="tooltip"></div>')

    if (!tip || tip == '') return false

    target.removeAttr('title')
    tooltip.css('opacity', 0).html(tip).appendTo('body')

    var init_tooltip = function () {
      if ($(window).width() < tooltip.outerWidth() * 1.5) tooltip.css('max-width', $(window).width() / 1.8)
      else tooltip.css('max-width', 340)

      var pos_left = target.offset().left + target.outerWidth() / 2 - tooltip.outerWidth() / 2,
        pos_top = target.offset().top - tooltip.outerHeight() - 20

      if (pos_left < 0) {
        pos_left = target.offset().left + target.outerWidth() / 2 - 20
        tooltip.addClass('left')
      } else tooltip.removeClass('left')

      if (pos_left + tooltip.outerWidth() > $(window).width()) {
        pos_left = target.offset().left - tooltip.outerWidth() + target.outerWidth() / 2 + 20
        tooltip.addClass('right')
      } else tooltip.removeClass('right')

      // if (pos_top < 0) {
      // console.log(target)
      var pos_top = target[0].getBoundingClientRect().bottom
      tooltip.addClass('top')
      // } else tooltip.removeClass('top')

      tooltip.css({ left: pos_left, top: pos_top, position: 'fixed' }).animate({ top: '+=10', opacity: 1 }, 50)
    }

    init_tooltip()
    $(window).resize(init_tooltip)

    var remove_tooltip = function () {
      tooltip.animate({ top: '-=10', opacity: 0 }, 50, function () {
        $(this).remove()
      })

      target.attr('title', tip)
    }

    target.bind('mouseleave', remove_tooltip)
    tooltip.bind('click', remove_tooltip)
  })
})

/* AK_DR ignored because of changed position of to sticky instead of fixed
/*
$(window).scroll(function () {
  document.documentElement.style.setProperty('--header-height', document.getElementById('shopify-section-header').clientHeight + 'px')
})
*/

$(function () {
  var urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('toast')) {
    // Get the snackbar DIV
    var x = document.getElementById('snackbar')

    // Add the "show" class to DIV
    x.className = 'show'
    x.innerHTML = '<strong>' + urlParams.get('toast').toUpperCase() + '</strong>'

    // After 5 seconds, remove the show class from DIV
    setTimeout(function () {
      x.className = x.className.replace('show', '')
    }, 10000)
  }
})

window.onload = function () {
  var cssRoot = getComputedStyle(document.documentElement)
  var offsetForFixedHeader = parseInt(cssRoot.getPropertyValue('--header-height'))

  function scrollToElement(element) {
    var elementPosition = element.getBoundingClientRect().top + window.pageYOffset
    window.scrollTo({
      top: elementPosition - offsetForFixedHeader - 30,
      behavior: 'smooth',
    })
  }
  function toggleFaqItem(faqItem, expand = true) {
    var faqQuestionButton = faqItem.querySelector('.Faq__Question')
    var faqAnswerWrapper = faqItem.querySelector('.Faq__AnswerWrapper')

    if (expand) {
      faqItem.setAttribute('aria-expanded', 'true')
      faqQuestionButton.setAttribute('aria-expanded', 'true')
      faqAnswerWrapper.classList.add('Faq__AnswerWrapper--expanded')
      faqAnswerWrapper.setAttribute('aria-hidden', 'false')
    } else {
      faqItem.setAttribute('aria-expanded', 'false')
      faqQuestionButton.setAttribute('aria-expanded', 'false')
      faqAnswerWrapper.classList.remove('Faq__AnswerWrapper--expanded')
      faqAnswerWrapper.setAttribute('aria-hidden', 'true')
    }
  }

  if (window.location.hash) {
    var anchorElement = document.querySelector(window.location.hash + '.anchor')
    if (anchorElement) {
      scrollToElement(anchorElement)

      var faqItem = anchorElement.closest('.Faq__Item')
      if (faqItem) {
        toggleFaqItem(faqItem)
      }
    }
  }
}

/* Google maps - start */
/* add 1 to the counter if you incounter pain inducing problems  */
/* pain counter: 129 */
let map
let directionsRenderer, directionsService
let currentInfoWindow = null
let markersAndInfoWindows = {} // Store markers and info windows by shop name
let debounceTimeout

function initMap() {
  map = new google.maps.Map(document.getElementById('map'), {
    center: { lat: 47.0, lng: 8.0 },
    zoom: 7,
    disableDefaultUI: true,
  })

  directionsService = new google.maps.DirectionsService()
  directionsRenderer = new google.maps.DirectionsRenderer()
  directionsRenderer.setMap(map)

  const directionsPanel = document.getElementById('directionsPanel')
  directionsRenderer.setPanel(directionsPanel)

  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        let userLocation = new google.maps.LatLng(position.coords.latitude, position.coords.longitude)
      },
      function () {
        handleLocationError(true, map.getCenter())
      }
    )
  } else {
    // Browser doesn't support Geolocation
    handleLocationError(false, map.getCenter())
  }

  // Generating markers and info windows for each store
  stores.forEach((store) => {
    let marker = new google.maps.Marker({
      position: { lat: store.LatLong.lat, lng: store.LatLong.lng },
      map: map,
      title: store.Shop,
    })

    let infowindow = new google.maps.InfoWindow({
      content: generateInfoWindowContent(store),
    })

    marker.addListener('click', function () {
      if (currentInfoWindow) currentInfoWindow.close()
      infowindow.open(map, marker)
      currentInfoWindow = infowindow
      updateActiveStoreListItem(store.Shop)
    })

    infowindow.addListener('closeclick', function () {
      removeActiveClassFromStoreListItem(store.Shop)
      resetMapView()
    })

    // Store marker and info window by shop name
    markersAndInfoWindows[store.Shop] = { marker, infowindow }
  })

  // adding active class to the selected shop
  function updateActiveStoreListItem(shopName) {
    const items = document.querySelectorAll('.storelistItem')
    items.forEach((item) => {
      if (item.getAttribute('data-shop-name') === shopName) {
        item.classList.add('active')
      } else {
        item.classList.remove('active')
      }
    })
  }

  // removing active class to the selected shop
  function removeActiveClassFromStoreListItem(shopName) {
    const item = document.querySelector(`.storelistItem[data-shop-name="${shopName}"]`)
    if (item) {
      item.classList.remove('active')
    }
  }

  // reseting the map view to the default
  function resetMapView() {
    map.setZoom(7)
    map.setCenter({ lat: 47.0, lng: 8.0 })
  }

  // Add event listener for search input & debounce
  const searchInput = document.getElementById('searchInput')
  searchInput.addEventListener('input', function () {
    clearTimeout(debounceTimeout)
    debounceTimeout = setTimeout(() => {
      const searchValue = searchInput.value
      const isNumeric = /^\d+$/.test(searchValue)
      console.log('Search value:', searchValue, 'Is numeric:', isNumeric)

      if (isNumeric) {
        searchStoresByPostalCode(stores, searchValue)
      } else {
        searchStores(stores, searchValue)
      }
    }, 700) // Adjust debounce time as needed
  })

  loadAllStores()
}

// Function for generating the info window content - on pop up of the markers
function generateInfoWindowContent(store) {
  let openingHours = store['Opening Hours'].map((hour) => `${hour.Tag}: ${hour.Uhrzeit}`).join('<br>')
  let address = store.Address.join(', ')

  return `
    <div class="store-info">
      <h3 class="shopHeader">${store.Shop}</h3>
      <p class="openingHours">${openingHours}</p>
      <p class="windowAdress">${store.Address.join('<br>')}</p>
      <button onclick='setDestinationAndFocusOrigin("${address.replace(/"/g, '&quot;')}")'>Route berechnen</button>
    </div>
  `
}

// Function to set the destination and focus on the origin input field
function setDestinationAndFocusOrigin(address) {
  // Set the destination input field to the shop's address
  let destinationInput = document.getElementById('destinationInput')
  destinationInput.value = address

  // Focus on the origin input field
  let originInput = document.getElementById('locationInput')
  originInput.focus()

  // Trigger the rotate effect and open the dropdown map
  let accordionButton = document.getElementById('dropdownMap')
  // accordionButton.classList.add('rotateOpen');

  let storeDropdown = document.getElementById('storeDropdown')
  storeDropdown.style.display = 'none'

  let searchInput = document.getElementById('searchInput')
  searchInput.style.display = 'none'

  // Open the dropdown map
  let dropdownContent = document.getElementById('dropdownContent')
  dropdownContent.style.display = 'block'

  // Reset the map and directions
  if (directionsRenderer) {
    directionsRenderer.setMap(map)
    directionsRenderer.setPanel(document.getElementById('directionsPanel'))
    if (currentInfoWindow) currentInfoWindow.close()
    originInput.focus()
  }
}

// Function to close the dropdown map and toggle between the route and the store list
const closeButton = document.querySelector('.closeButton')
const accordion = document.getElementById('accordion')
if (closeButton) {
  closeButton.addEventListener('click', function () {
    const dropdownContent = document.getElementById('dropdownContent')
    const storeDropdown = document.getElementById('storeDropdown')
    const locationInput = document.getElementById('locationInput')
    const destinationInput = document.getElementById('destinationInput')
    const searchInput = document.getElementById('searchInput')

    if (dropdownContent) {
      dropdownContent.style.display = 'none'
    }
    if (searchInput) {
      searchInput.style.display = 'block'
    }
    if (storeDropdown) {
      storeDropdown.style.display = 'grid'
    }
    if (locationInput) {
      locationInput.value = ''
    }
    if (destinationInput) {
      destinationInput.value = ''
    }

    if (directionsRenderer) {
      directionsRenderer.setMap(null)
      directionsRenderer.setPanel(null)
    }
    if (map) {
      map.setCenter({ lat: 47.0, lng: 8.0 })
      map.setZoom(7)
    }
    if (currentInfoWindow) {
      currentInfoWindow.close()
      currentInfoWindow = null
    }

    if (accordion.style.display === 'block') {
      accordion.style.display = 'none'
    }
  })
}

function extractPostalCode(addressArray) {
  const addressString = addressArray[addressArray.length - 1]
  const match = addressString.match(/\d+/g)
  return match ? match.join('') : ''
}

async function searchStores(stores, value) {
  const searchInput = document.getElementById('searchInput').value.toLowerCase()
  clearDropdown()

  // If search input is empty, reload all stores and return
  if (searchInput.length === 0) {
    await loadAllStores()
    return
  }

  const filteredStores = stores.filter(
    (store) =>
      store.Shop.toLowerCase().includes(searchInput) ||
      store.Address.join(' ').toLowerCase().includes(searchInput) ||
      store.Address.some((part) => part.toLowerCase().includes(searchInput))
  )

  if (filteredStores.length > 0) {
    filteredStores.forEach((store) => addToDropdown(store))
  } else {
    await loadAllStores()
  }
}

async function searchStoresByPostalCode(stores, postalCode) {
  const geocoder = new google.maps.Geocoder()
  const address = postalCode + ', Schweiz'

  geocoder.geocode({ address: address }, function (results, status) {
    if (status === google.maps.GeocoderStatus.OK) {
      const userLocation = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng())
      const storesWithDistances = stores.map((store) => {
        const storeLocation = new google.maps.LatLng(store.LatLong.lat, store.LatLong.lng)
        const distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(userLocation, storeLocation)
        const distanceInKilometers = distanceInMeters / 1000
        return { ...store, distance: distanceInKilometers }
      })

      const sortedStores = storesWithDistances.sort((a, b) => a.distance - b.distance)

      clearDropdown() // Clear the dropdown before adding the new stores
      if (sortedStores.length > 0) {
        sortedStores.forEach((store) => addToDropdown(store))
      } else {
        loadAllStores()
      }
    } else {
      console.log('Geocode was not successful for the following reason: ' + status)
      loadAllStores()
    }
  })
}

function selectStore(store) {
  const match = markersAndInfoWindows[store.Shop]
  if (match) {
    if (currentInfoWindow) currentInfoWindow.close()
    map.setCenter(match.marker.getPosition())
    map.setZoom(10)
    match.infowindow.open(map, match.marker)
    currentInfoWindow = match.infowindow
  }
}

function loadAllStores() {
  const dropdown = document.getElementById('storeDropdown')
  dropdown.innerHTML = '' // Clear the dropdown first

  const sortedStores = Object.values(stores).sort((a, b) => {
    const postalCodeA = extractPostalCode(a.Address)
    const postalCodeB = extractPostalCode(b.Address)
    return postalCodeA.localeCompare(postalCodeB)
  })

  sortedStores.forEach((store) => {
    store.distance = null // Ensure the distance field is reset
    addToDropdown(store)
  })
}

// Function for generating the stores in the dropdown
function addToDropdown(store) {
  const dropdown = document.getElementById('storeDropdown')
  const div = document.createElement('div')
  div.classList.add('storelistItem')
  var address = Array.isArray(store.Address) ? store.Address.join('<br>') : ''
  var openingHours = store['Opening Hours'].map((hour) => `${hour.Tag}: ${hour.Uhrzeit}`).join('<br> ')
  div.innerHTML =
    '<div class="storeHeader">' +
    store.Shop +
    '</div>' +
    '<div class="storeAddress">' +
    address +
    '</div>' +
    '<div class="storeHours">' +
    openingHours +
    '</div>' +
    '<div class="storeDistance">' +
    (store.distance !== null ? `${store.distance.toFixed(2)} km` : '') +
    '</div>'
  div.addEventListener('click', function () {
    selectStore(store)

    const storeDivs = dropdown.getElementsByClassName('storelistItem')
    for (let i = 0; i < storeDivs.length; i++) {
      storeDivs[i].classList.remove('active')
    }

    div.classList.add('active')
    div.setAttribute('data-shop-name', store.Shop)
  })
  dropdown.appendChild(div)
}

function clearDropdown() {
  const dropdown = document.getElementById('storeDropdown')
  dropdown.innerHTML = ''
  if (currentInfoWindow) currentInfoWindow.close()
  map.setCenter({ lat: 47.0, lng: 8.0 })
  map.setZoom(7)
}

function handleLocationError(browserHasGeolocation, pos) {
  alert(browserHasGeolocation ? 'Error: The Geolocation service failed.' : "Error: Your browser doesn't support geolocation.")
}

/* Function for calculating and displaying routes - direction */
function calculateAndDisplayRoute(origin, destination, travelMode = 'DRIVING') {
  directionsService.route(
    {
      origin: origin,
      destination: destination,
      travelMode: google.maps.TravelMode[travelMode],
    },
    (response, status) => {
      if (status === 'OK') {
        directionsRenderer.setDirections(response)
        const distance = response.routes[0].legs[0].distance.text
        const duration = response.routes[0].legs[0].duration.text.replace('Stunden', 'h')
        // Display distance and duration underneath the map
        document.getElementById(
          'outputDiv'
        ).innerHTML = `<div class="routeFlex"><div class="routeInfo">Entfernung:</div> ${distance}</div> <div class="routeFlex"><div class="routeInfo">Dauer:</div> ${duration}</div>`
        accordion.style.display = 'block'
      } else {
        window.alert('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
      }
    }
  )
}

function selectStoreDes(store) {
  const destination = new google.maps.LatLng(store.LatLong.lat, store.LatLong.lng)
  const originInput = document.getElementById('locationInput').value

  // Check if origin and destination are selected
  if (originInput && destination) {
    const selectedMode = document.querySelector('#mode div.selected').getAttribute('data-value')
    calculateAndDisplayRoute(originInput, destination, selectedMode)
  }
  clearDropdown()
}

// Event listener for travel mode selection
document.querySelectorAll('#mode div').forEach((modeElement) => {
  modeElement.addEventListener('click', function () {
    document.querySelectorAll('#mode div').forEach((div) => div.classList.remove('activeMode'))
    this.classList.add('activeMode')

    const originInput = document.getElementById('locationInput').value
    const destinationInput = document.getElementById('destinationInput').value

    // Only proceed if both origin and destination are provided
    if (originInput && destinationInput) {
      const selectedMode = this.getAttribute('data-value')
      calculateAndDisplayRoute(originInput, destinationInput, selectedMode)
    }
  })
})

const accordionButton = document.getElementById('accordionButton')
/* const accordion = document.getElementById('accordion'); */

if (accordionButton) {
  accordionButton.addEventListener('click', function () {
    var panel = document.getElementById('directionsPanel')
    var plus = document.getElementById('accordionIcon')
    if (panel && panel.style.display === 'none') {
      if (plus) {
        plus.style.transform = 'rotate(134deg)'
      }
      panel.style.display = 'block'
    } else {
      if (plus) {
        plus.style.transform = 'rotate(0deg)'
      }
      if (panel) {
        panel.style.display = 'none'
      }
    }
  })
}


window.initMap = initMap
/* Google maps - end */

/*  trustpilot carousel slider start */
const trustpilotCarousel = document.getElementById('trustpilot-carousel')
if (trustpilotCarousel) {
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('#trustpilot-carousel', {
      width: 1000,
      gap: '1rem',
      perMove: 3,
      pagination: false,
      padding: { left: '1rem', right: '1rem' },
      breakpoints: {
        640: {
          perMove: 1,
          perPage: 1,
        },
      },
    }).mount()

    const trustpilotCarousel = document.getElementById('trustpilot-carousel')
    const lis = trustpilotCarousel.querySelectorAll('.splide__slide');

    const ul = trustpilotCarousel.querySelector('.splide__list');

    lis.forEach((li) => {
      li.removeAttribute('role');
      li.setAttribute('role', 'listitem');
    })

    ul.removeAttribute('role');
    ul.setAttribute('role', 'list');

  })
}
/*  trustpilot carousel slider end */

/* meili start */
document.addEventListener('DOMContentLoaded', function () {
  const toggleSearchButtons = document.querySelectorAll('[data-action="toggleMeilisearch"]')
  const searchMeiliSearch = document.querySelector('[data-action="search-meilisearch"]')
  const closeSearchButton = document.querySelector('.meilisearch__Close')
  const searchContainer = document.querySelector('.meilisearch')
  const overlay = document.querySelector('.overlay')
  const searchInput = Alpine.store('meilimetaNew').enabled ? document.querySelector('.meiliInputHeaderNew') : document.querySelector('.meiliInputHeader');
  const searchForm = Alpine.store('meilimetaNew').enabled ? document.querySelector('.resultsFlex.new') : document.querySelector('.resultsFlex');
  searchContainer.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault()
    }
  })


  function onReady() {
    const filterButton = document.getElementById('filter-button-mobile');
    const filterCategoryMobile = document.querySelector('.filterCategory-mobile');
    const filterCloseMobile = document.getElementById('filter-close-mobile');
    const filterFlexInput = document.querySelectorAll('.filter-flex input');
    if (!filterButton && filterCategoryMobile) return;
    if (!Alpine.store('meilimetaNew').enabled) {
      filterButton.addEventListener('click', (e) => {
        e.preventDefault();
        filterCategoryMobile.classList.toggle('isOpen');
      });

      if (!filterCloseMobile) return;
      filterCloseMobile.addEventListener('click', (e) => {
        e.preventDefault();
        filterCategoryMobile.classList.remove('isOpen');
      });
    }


    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      filterCategoryMobile.classList.add('safari');
    }
  }

  onReady();

  async function createFilterChips() {
    try {
      const oldChipContainer = document.querySelector(".filterChipContainer");
      if (oldChipContainer) {
        return;
      }

      const response = await fetch("https://suche.ankerkraut.de/search/most").then((res) => res.json());

      const container = document.createElement("div");
      container.classList.add("filterChipContainer");

      const filterChipTitle = window.innerWidth > 768 ? document.createElement("div") : null;
      if (filterChipTitle) {
        filterChipTitle.classList.add("filterChipTitle");
        filterChipTitle.textContent = "Meist gesuchte Begriffe:";
        container.appendChild(filterChipTitle);
      }

      let resultHeader = document.querySelector('.filter-header-mobile');
      if (Alpine.store("meilimetaNew").enabled) {
        resultHeader = document.querySelector('.newSearchBarWrapper');
      }
      response.forEach((item) => {
        if ((container.children.length >= 8 && window.innerWidth <= 768) || container.children.length >= 10) {
          return; // Limit to 10 chips
        }
        const filterChip = document.createElement("div");
        filterChip.classList.add("filterChip");
        filterChip.textContent = `🔥 ${item.q}`;
        const store = Alpine.store('meiliheader');
        filterChip.addEventListener("click", () => {
          const meilisearchInput = document.getElementById("meilisearch");
          if (searchInput) {
            meilisearchInput.value = item.q;
            searchInput.value = item.q;
            store.query = item.q;
            store.search();
            if (Alpine.store('meilimetaNew').enabled) {
              handleInput();
            }
          }
        });
        container.appendChild(filterChip);
      });
      if (!Alpine.store("meilimetaNew").enabled) {
        if (window.innerWidth <= 768) {
          resultHeader.insertAdjacentElement("afterend", container);
        } else {
          document.querySelector(".meiliInputHeader").insertAdjacentElement("afterend", container);
        }
      } else {
        resultHeader.insertAdjacentElement("afterend", container);
      }
    } catch (error) {
      console.error("Error fetching most searched terms:", error);
    }
  }

  function openSearch() {
    createFilterChips();
    Alpine.store('meiliheader').open = true;
    let newEnabled = Alpine.store('meilimetaNew').enabled;
    if (newEnabled) {
      Alpine.store('meiliheader').search();
      if (Alpine.store('meiliNewProductsVisible').enabled || searchInput.value.trim() !== '') {
        searchForm.classList.add('isOpen');
      }
    }
    if (searchContainer.getAttribute('aria-expanded') != null) {
      searchContainer.setAttribute('aria-expanded', 'true')
    } else {
      searchContainer.setAttribute('aria-hidden', 'false')
    }
    overlay.style.display = 'block';
    document.body.classList.add('no-scroll');
    if (!newEnabled) {
      overlay.style.opacity = '1';
    }
    if (!Alpine.store('meilimetaNew').enabled || Alpine.store('meilimetaNew').enabled && window.innerWidth > 768) {
      toggleSearchButtons.forEach(function (toggleSearchButton) {
        toggleSearchButton.style.display = 'none'
      })
    }
    setTimeout(function () {
      searchInput.focus()
    }, 100)
  }

  window.openSearch = openSearch;

  function closeSearch(event) {
    // remove the filterChips container
    Alpine.store('meiliheader').open = false;
    closeSearchButton.blur();
    const filterChipContainer = document.querySelector(".filterChipContainer");
    if (filterChipContainer) {
      filterChipContainer.remove();
    }
    if (event) event.preventDefault()
    if (searchContainer.getAttribute('aria-expanded') != null){
      searchContainer.setAttribute('aria-expanded', 'false')
    } else {
      searchContainer.setAttribute('aria-hidden', 'true')
    }
    searchContainer.style.setProperty('--meili-after-visibility', 'hidden');
    overlay.style.display = 'none';
    document.body.classList.remove('no-scroll');
    if (!Alpine.store('meilimetaNew').enabled || Alpine.store('meilimetaNew').enabled && window.innerWidth > 768) {
      toggleSearchButtons.forEach(function (toggleSearchButton) {
        toggleSearchButton.style.display = 'inline-block'
      })
    }
    searchInput.blur()
    searchContainer.classList.remove('has-results')
    searchForm.classList.remove('isOpen')
  }

  window.closeSearch = closeSearch;

  function handleInput() {
    const resultsContainer = document.querySelector('.resultsFlex');
    if (searchInput.value.trim() === '' && ((Alpine.store('meilimetaNew').enabled && !Alpine.store('meiliNewProductsVisible').enabled) || !Alpine.store('meilimetaNew').enabled)) {
      // resultsContainer.style.display = 'none'
      searchForm.classList.remove('isOpen')
      searchContainer.classList.remove('has-results')
    } else {
      resultsContainer.classList.add('isOpen')
    }
  }

  function toggleMeiliSearch(event) {
    if (event) {
      event.preventDefault()
    }
    if (searchContainer) {
      let isInactive = false;
      if (searchContainer.getAttribute('aria-expanded') != null) {
        isInactive = searchContainer.getAttribute('aria-expanded') === 'false'
      } else {
        isInactive = searchContainer.getAttribute('aria-hidden') === 'true'
      }
      if (isInactive) {
        openSearch()
      } else {
        closeSearch()
      }
    }
  }

  if (closeSearchButton) {
    closeSearchButton.addEventListener('click', function (event) {
        closeSearch(event)
      })
  }

  toggleSearchButtons.forEach(function (toggleSearchButton) {
    toggleSearchButton.addEventListener('click', toggleMeiliSearch)
  })

  if (searchInput) {
    searchInput.addEventListener('input', handleInput)
  }

  if (searchInput && Alpine.store('meilimetaNew').enabled) {
    searchInput.addEventListener('click', function (event) {
      event.preventDefault();
      if (searchContainer.getAttribute('aria-expanded') === 'false') {
        openSearch();
      }
    });
  }

  if (searchContainer) {
    document.addEventListener('click', function (event) {
      const isClickInside = searchContainer.contains(event.target)
      const isClickOnToggle = Array.from(toggleSearchButtons).some((button) => button.contains(event.target))
      const filterOverlay = document.querySelector('.filterCategory-mobile-new');
      const filterOverlayStyle = window.getComputedStyle(filterOverlay);
      const notConsiderMobileFilter = filterOverlayStyle.display === 'block' ? Math.round(parseFloat(filterOverlayStyle.left)) >= window.innerWidth : true;
      if (!isClickInside && !isClickOnToggle && overlay.style.display === 'block' && notConsiderMobileFilter) {
        closeSearch()
      }
    })
  }

  document.querySelector('.meilisearch').addEventListener('click', function (event) {
    let rect = this.getBoundingClientRect();
    const filterCategoryMobile = document.querySelector('.filterCategory-mobile');
    if (event.clientX > rect.right || event.clientY > rect.bottom || event.clientX < rect.left || event.clientY < rect.top) {
      if (!filterCategoryMobile.contains(event.target)) {
        closeSearch();
      }
    }
  });
})
/* meili end */

/* Cart drawer external click - start */
const openDrawer = document.querySelector('[data-action="open-drawer"]')
const cartDrawer = document.getElementById('sidebar-cart')
// add Alpine check for data toggle
const toggleSearch = document.getElementsByClassName('Header__Icon Icon-Wrapper Icon-Wrapper--clickable hidden-phone ')[4]
const toggleSearchNew = document.querySelectorAll('[data-action="toggle-search"]')
const searchField = document.getElementById('Search')

// Function to adjust the disabled state based on cartDrawer's aria-hidden status
function adjustDisabledState() {
  if (cartDrawer) {
    const ariaHidden = cartDrawer.getAttribute('aria-hidden')
    if (toggleSearch !== undefined) {
      if (ariaHidden === 'false') {
        toggleSearch.classList.add('disabled')
      } else {
        if (toggleSearch.classList.contains('disabled')) toggleSearch.classList.remove('disabled')
      }
    }
    if (toggleSearchNew.length > 0) {
      toggleSearchNew.forEach(button => {
        if (ariaHidden === 'false') {
          button.classList.add('disabled')
        } else {
          if (button.classList.contains('disabled')) button.classList.remove('disabled')
        }
      })
    }
  }
}

// Function to adjust the disabled state based on search's aria-hidden status
function adjustSearchDisabledState() {
  const searchAriaHidden = searchField.getAttribute('aria-hidden')
  if (searchAriaHidden === 'false') {
    openDrawer.classList.add('disabled')
  } else {
    openDrawer.classList.remove('disabled')
  }
}

// Set up a mutation observer to listen for changes to the 'aria-hidden' attribute
if (cartDrawer) {
  const cartOsbserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'aria-hidden') {
        adjustDisabledState()
      }
    })
  })

  cartOsbserver.observe(cartDrawer, { attributes: true })
}

const searchObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'aria-hidden') {
      adjustSearchDisabledState()
    }
  })
})

searchObserver.observe(searchField, { attributes: true })

adjustDisabledState()
adjustSearchDisabledState()

openDrawer.addEventListener('click', function (event) {
  const currentAriaHidden = cartDrawer.getAttribute('aria-hidden') === 'true' ? 'false' : 'true'
  cartDrawer.setAttribute('aria-hidden', currentAriaHidden)
})

if (toggleSearch !== undefined) {
  toggleSearch.addEventListener('click', function (event) {
    const currentSearchAriaHidden = searchField.getAttribute('aria-hidden') === 'true' ? 'false' : 'true'
    searchField.setAttribute('aria-hidden', currentSearchAriaHidden)
    adjustSearchDisabledState()
  })
}
/* Cart drawer external click - end */

/* Cart | Reco API Upsell - start */
const sidebarCart = document.getElementById('sidebar-cart')
if (sidebarCart) {
  const upsellObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        let mobileDrawer = document.querySelector('.mobile-drawer-upsell__products-wrapper')
        if (sidebarCart.getAttribute('aria-hidden') === 'false' && mobileDrawer) {
          setTimeout(() => {
            mobileDrawer.style.overflowX = 'scroll'
            const startValue = 0
            const endValue = 100
            const duration = 700
            let startTime = performance.now()

            function animateScroll() {
              const currentTime = performance.now()
              const elapsed = currentTime - startTime
              const progress = Math.min(elapsed / duration, 1)
              const scrollValue = startValue + (endValue - startValue) * progress
              mobileDrawer.scrollLeft = scrollValue

              if (progress < 1) {
                requestAnimationFrame(animateScroll)
              }
            }

            function animateOutScroll() {
              const currentTime = performance.now()
              const elapsed = currentTime - startTime
              const progress = Math.min(elapsed / duration, 1)
              const scrollValue = endValue - (endValue - startValue) * progress
              mobileDrawer.scrollLeft = scrollValue

              if (progress < 1) {
                requestAnimationFrame(animateOutScroll)
              }
            }

            requestAnimationFrame(animateScroll)

            setTimeout(() => {
              startTime = performance.now() // Reset startTime
              requestAnimationFrame(animateOutScroll)
            }, 1000)
          }, 2000)
        }
      }
    })
  })

  upsellObserver.observe(sidebarCart, {
    attributes: true,
  })
}

/* Cart | Reco API Upsell - end */

/* BIO Variant POPOVER - start */
const bioVariant = document.querySelector('.Variant__Bio')
const popoverBio = document.querySelector('.popover-bio')

if (bioVariant && popoverBio) {
  bioVariant.addEventListener('mouseenter', function () {
    popoverBio.showPopover()
  })

  bioVariant.addEventListener('mouseleave', function () {
    popoverBio.hidePopover()
  })
}
/* BIO Variant POPOVER - end */

/* JS Fix for abo box - start */
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.href.includes('/pages/abo-box')) {
    const flicktySlider = document.querySelector('.flickity-page-dots')
    const flickityPrevBtn = document.querySelector('.Product__SlideshowNavArrow.Product__SlideshowNavArrow--previous')
    const flickityNexBtn = document.querySelector('.Product__SlideshowNavArrow.Product__SlideshowNavArrow--next')
    const variantRadios = document.querySelectorAll('.SizeSwatch__Radio')
    let index = 0

    function updateVisibleImages() {
      const totalImages = flicktySlider.children.length
      for (let i = 0; i < totalImages; i++) {
        flicktySlider.children[i].style.display = 'none'
      }

      if (index === 0) {
        flicktySlider.children[index].style.display = 'inline-block'
        if (flicktySlider.children[index + 1]) {
          flicktySlider.children[index + 1].style.display = 'inline-block'
        }
        if (flicktySlider.children[index + 2]) {
          flicktySlider.children[index + 2].style.display = 'inline-block'
        }
      } else if (index === totalImages - 1) {
        if (flicktySlider.children[index - 2]) {
          flicktySlider.children[index - 2].style.display = 'inline-block'
        }
        if (flicktySlider.children[index - 1]) {
          flicktySlider.children[index - 1].style.display = 'inline-block'
        }
        flicktySlider.children[index].style.display = 'inline-block'
      } else {
        if (flicktySlider.children[index - 1]) {
          flicktySlider.children[index - 1].style.display = 'inline-block'
        }
        flicktySlider.children[index].style.display = 'inline-block'
        if (flicktySlider.children[index - 1]) {
          flicktySlider.children[index + 1].style.display = 'inline-block'
        }
      }
    }

    flickityPrevBtn.addEventListener('click', function () {
      if (index > 0) {
        index--
        updateVisibleImages()
      }
    })

    flickityNexBtn.addEventListener('click', function () {
      if (index < flicktySlider.children.length - 1) {
        index++
        updateVisibleImages()
      }
    })

    variantRadios.forEach((radio) => {
      radio.addEventListener('change', function () {
        const variantIndex = Array.from(variantRadios).indexOf(radio)
        index = variantIndex
        updateVisibleImages()
      })
    })

    updateVisibleImages()

    /* Flickity slider PDP rebrush - start */
    const images = Array.from(document.querySelectorAll('.Product__Slideshow img')).map((item) => item.dataset.src || item.src)

    const dots = document.querySelectorAll('.Product__SlideshowMobileNav .dot')

    if (dots.length > 0) {
      dots.forEach((item, index) => {
        if (images[index]) {
          item.style.background = `url("${images[index]}")`
          item.style.backgroundSize = 'cover'
        }
      })
    } else {
      if (!document.querySelector('.Product__SlideshowMobileNav')) {
        document.querySelector('.Product__Gallery').classList.add('gg-no-thumbs')
      }
    }

    const productSlider = document.querySelector('.Product__Slideshow')
    const productSliderMobile = document.querySelector('.Product__SlideshowMobileNav')
    const productActionlist = document.querySelector('.Product__ActionList')

    const slideshowWrapper = document.createElement('div')
    slideshowWrapper.classList.add('Product__Slideshow--wrapper')
    slideshowWrapper.classList.add('abo-box')

    const slideshowMobileWrapper = document.createElement('div')
    slideshowWrapper.appendChild(productSlider)

    productActionlist.insertAdjacentElement('afterend', slideshowWrapper)

    const flicktyFlex = document.createElement('div')
    flicktyFlex.classList.add('flicktyFlex')
    flicktyFlex.appendChild(slideshowWrapper)
    flicktyFlex.appendChild(productSliderMobile)

    productActionlist.insertAdjacentElement('afterend', flicktyFlex)
  }
})
/* JS Fix for abo box - end */

/* JS for normal-recipe-cart-product's background */
document.addEventListener('DOMContentLoaded', () => {
  const recipeProducts = document.querySelectorAll('.normal-recipe-product')
  recipeProducts.forEach((product, index) => {
    if (index % 2 === 0) {
      product.style.backgroundColor = 'rgba(173, 173, 173, 0.15)'
    }
  })
})

document.addEventListener('DOMContentLoaded', function () {
  var wakeLock = null
  const cookBtn = document.getElementById('cook-button')
  const cookModeSlider = document.getElementById('cook-mode-slider')
  let splideInstance = null
  const closeBtn = document.createElement('button')
  closeBtn.textContent = 'X'
  const svgContent = `
      <svg role="button" aria-label="Schließen" width="24px" height="24px" class="close--icon" viewBox="0 0 48 48" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" fill="#5c5c5c" stroke="#5c5c5c">
        <g stroke-width="0"/>
        <g stroke-linecap="round" stroke-linejoin="round"/>
        <g>
          <defs>
            <style>.cls-1{fill:none;stroke:#5c5c5c;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}</style>
          </defs>
          <title/>
          <circle class="cls-1" cx="24" cy="24" r="23"/>
          <line class="cls-1" x1="12" x2="36" y1="12" y2="36"/>
          <line class="cls-1" x1="12" x2="36" y1="36" y2="12"/>
        </g>
      </svg>
  `
  closeBtn.innerHTML = svgContent
  closeBtn.style.position = 'fixed'
  closeBtn.style.top = '20px'
  closeBtn.style.right = '20px'
  closeBtn.style.zIndex = '10000'
  closeBtn.style.display = 'none'
  document.body.appendChild(closeBtn)

  function releaseWakeLock() {
    if (wakeLock !== null) {
      wakeLock
        .release()
        .then(() => {
          wakeLock = null
          console.log('WakeLock released')
        })
        .catch((err) => {
          console.error(`${err.name}, ${err.message}`)
        })
    }
  }

  if (cookBtn !== null) {
    cookBtn.addEventListener('click', async function () {
      if (!document.body.classList.contains('no-scroll-slider')) {
        document.body.classList.add('no-scroll-slider')
        cookModeSlider.classList.add('no-scroll-slider')
      }
      try {
        wakeLock = await navigator.wakeLock.request('screen')
        if (!splideInstance) {
          splideInstance = new Splide(cookModeSlider, {
            type: 'fade',
            perPage: 1,
            gap: 0,
            padding: 0,
            rewind: false,
            width: '100vw',
            height: '100vh',
            cover: true,
            autoplay: false,
          })

          splideInstance.mount()

          const ingriedentBtns = document.querySelectorAll('.ingriedent-button');
          if (ingriedentBtns != undefined) {
            ingriedentBtns.forEach((btn) => {
              btn.addEventListener('click', function (e) {
                splideInstance.go(1);
              })
            })
          }

          cookModeSlider.style.display = 'block'
          cookModeSlider.style.position = 'fixed'
          cookModeSlider.style.top = '0'
          cookModeSlider.style.left = '0'
          cookModeSlider.style.zIndex = '9999'

          closeBtn.style.display = 'block'

          cookBtn.style.display = 'none'
        } else {
          cookModeSlider.style.display = 'block'
          cookBtn.style.display = 'none'
          closeBtn.style.display = 'block'
        }
      } catch (error) {
        console.log('WakeLock not supported')
      }
    })
  }

  if (closeBtn !== null) {
    closeBtn.addEventListener('click', function () {
      cookModeSlider.style.display = 'none'
      cookBtn.style.display = 'block'
      closeBtn.style.display = 'none'
      if (document.body.classList.contains('no-scroll-slider')) {
        document.body.classList.remove('no-scroll-slider')
        cookModeSlider.classList.remove('no-scroll-slider')
      }
      releaseWakeLock()
    })
  }
})

/* JS for normal-recipe-cart-product's background */

// -- Function for blog search --
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.href.includes('/blogs/')) return;

  const elements = {
    blogInput: document.getElementById('blog-input'),
    blogGrid: document.querySelector('.blog-grid'),
    blogRecipeGrid: document.querySelector('.blog-recipe-grid'),
    searchBlogContainer: document.querySelector('.search-blog-container'),
    customOverlay: document.querySelector('.CustomOverlay'),
    body: document.body
  };

  if (window.Shopify.country !== 'DE') {
    const searchBlog = document.querySelector('.search-blog');
    if (!searchBlog) return;
    searchBlog.style.display = 'none';
  }
});

document.querySelectorAll(".accordion-toggle").forEach((btn) => {
  // console.log(BigInt)
  const filterCategory = document.querySelector(".filterCategory-mobile");
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    const content = document.getElementById(btn.dataset.target);

    const isOpen = content.style.display === "block";
    content.style.display = isOpen ? "none" : "block";

    btn.classList.toggle("active", !isOpen);
    if (btn.querySelector("span")) {
      if (btn.querySelector("span").innerText === "mehr anzeigen") {
        btn.querySelector("span").innerText = "weniger anzeigen";
      } else {
        btn.querySelector("span").innerText = "mehr anzeigen";
      }
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  // console.log("loading");
  setTimeout(() => {
    const cleverpushBell = document.querySelector('.cleverpush-bell');
    if (cleverpushBell) {
      /* cleverpushBell.removeAttribute('role');
      console.log("rmeove the attribute"); */
      cleverpushBell.removeAttribute('role');
      cleverpushBell.setAttribute('aria-label', 'Benachrichtigungen');
      cleverpushBell.setAttribute('aria-haspopup', 'dialog');
      const confirmBtn = document.querySelector('.cleverpush-confirm-btn.cleverpush-confirm-btn-allow');
      // console.log("confirm btn", confirmBtn);
      if (confirmBtn) {
        setTimeout(() => {
          confirmBtn.style.background = '#0B4DA2';
          // console.log("setting color");
        }, 500);
      }
    }
  }, 4000);


  /* -- changing splides buttons svgs to meaningfull -- */
  const nextBtns = document.querySelectorAll('.splide__arrow.splide__arrow--next');
  const prevBtns = document.querySelectorAll('.splide__arrow.splide__arrow--prev');
  setTimeout(() => {
    nextBtns.forEach((btn) => {
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('alt', 'nächste slide');
        svg.setAttribute('aria-label', 'nächste slide');
        svg.setAttribute('role', 'img');
      }
    });
    prevBtns.forEach((btn) => {
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('alt', 'nächste slide');
        svg.setAttribute('aria-label', 'nächste slide');
        svg.setAttribute('role', 'img');
      }
    });
  }, 4000);



    // ### iconbar #### 
    const iconBar = document.querySelector('.icon_bar');
    // const iconBarOffset = iconBar.getBoundingClientRect();
    const quantitySelector = document.querySelector('.ProductForm__QuantitySelector');
    const deliveryTrackerNotification = document.querySelector('.deliveryTracker_shipping_notification');

    const cssObj = window.getComputedStyle(iconBar);
    let cssObj_bottom = parseFloat(cssObj.getPropertyValue('bottom').match(/[\d\.]+/)[0]);

    if(deliveryTrackerNotification) {
        iconBar.style.setProperty('bottom', cssObj_bottom + deliveryTrackerNotification.offsetHeight +'px');
    }

    let lastKnownScrollPosition = 0;
    let ticking = false;

    function doSomething(scrollPos) {   
        if(quantitySelector) {
            if(quantitySelector.classList.contains('sticky_atc_fixed') && window.innerWidth < 1000) {
                iconBar.style.setProperty('bottom', 30 + cssObj_bottom + quantitySelector.offsetHeight +'px');
            } else {
                iconBar.style.setProperty('bottom', cssObj_bottom +'px')
            }
        }
    }

    document.addEventListener('scroll', (event) => {
        lastKnownScrollPosition = window.scrollY;

        if (!ticking) {
            window.requestAnimationFrame(() => {
                doSomething(lastKnownScrollPosition);
                ticking = false;
            });

            ticking = true;
        }
    });


});